import React, { useEffect, useRef, useState } from "react";
import "./Reports.css";
import { Col, Row, Container, Modal, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { GetCustomerAllReports, GetReportList } from "../../apis/ReportsAPI";
import { Link, useNavigate } from "react-router-dom";
import { ReportFilter } from "../../components/SearchFilter/ReportFilter";
import { filterBy } from "@progress/kendo-data-query";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Reports() {
  const {user} = useSelector((state) => state.auth);
  const [customerReportdata, setCustomerReportData] = useState([]);
  const [visible, setVisible] = useState(9);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [isSearchedData, setIsSearchedData] = useState(false);
  const [reportTypes, setReportTypes] = useState([]);
  const [allReport, setAllReport] = useState([]);
  const [isSorting, setIsSorting] = useState(false);
  const [sortingField, setSortingField] = useState("order_id");
  const [sortingOrder, setSortingOrder] = useState("desc");
  const navigate = useNavigate();

  const searchBody = useRef();
  const loadMoreData = () => {
    setVisible((prevValue) => prevValue + 9);
  };

  async function GetReportData(oldlist) {
    let body = searchBody.current;
    var result = await GetReportList(body);
    var data = result.data;
    if (oldlist.length > 0 && !isSorting) {
      let list = JSON.parse(JSON.stringify(oldlist));
      list.push(...data);
      setCustomerReportData(list);
    } else setCustomerReportData(data);
    if (data.length > 0) setTotalRecord(data[0].totalRows);
  }

  const getReportList = async () => {
    var result = await GetCustomerAllReports(user.customerid);
    setAllReport(result.data.slice());
    setReportTypes(result.data.slice());
  };

  const filterData = (filter) => {
    const data = allReport.slice();
    return filterBy(data, filter);
  };

  const reportFilterChange = (e) => {
    setReportTypes(filterData(e.filter));
  };

  useEffect(() => {
    getReportList();
  }, []);

  useEffect(() => {
    if (visible < totalRecord) {
      setShowLoadMore(true);
    } else setShowLoadMore(false);
    if (visible / 9 > pageCount) setPageCount((prevValue) => prevValue + 1);
  }, [visible, totalRecord]);

  useEffect(() => {
    var pgSize = 9;
    var pgCount = pageCount;
    if (isSorting) {
      pgSize = pageCount * 9;
      pgCount = 1;
    }
    if (!isSearchedData) {
      searchBody.current = {
        pageNo: pgCount + "",
        pageSize: pgSize + "",
        requestor_id: user.requestorid,
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };
    } else searchBody.current.pageNo = pageCount + "";
    if (pageCount === 1) GetReportData([]);
    else GetReportData(customerReportdata);
  }, [pageCount, sortingField, sortingOrder]);

  const handleSearch = async (searchValue) => {
    setPageCount(1);
    setIsSorting(false);
    searchValue === "" ? setIsSearchedData(false) : setIsSearchedData(true);
    searchBody.current = {
      order_applicant_name: searchValue,
      pageNo: "1",
      pageSize: "9",
      requestor_id: user.requestorid,
      sortingField: sortingField,
      sortingOrder: sortingOrder,
    };
    if (pageCount === 1) await GetReportData([]);
  };

  const handleAdvanceSearch = async (searchData) => {
    setPageCount(1);
    setIsSearchedData(true);
    setIsSorting(false);
    let completionSearch = false;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
      completionSearch = true;

    let doSearch = false;

    if (
      completionSearch ||
      (searchData.applicantName != null && searchData.applicantName !== "") ||
      searchData.reportType.report_id !== 0
    )
      doSearch = true;

    if (doSearch) {
      searchBody.current = {
        requestor_id: user.requestorid,
        completion_start_date:
          completionSearch === true
            ? dateFormat(searchData.completionStartDate, "yyyy-mm-dd")
            : "",
        completion_end_date:
          completionSearch === true
            ? dateFormat(searchData.completionEndDate, "yyyy-mm-dd")
            : "",
        order_applicant_name: searchData.applicantName,
        report_id:
          searchData.reportType.report_id === 0
            ? ""
            : searchData.reportType.report_id + "",
        pageNo: "1",
        pageSize: "9",
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };
    }

    if (pageCount === 1) await GetReportData([]);
  };

  const handleSorting = (sorting) => {
    setIsSorting(true);
    var sortingField = sorting.value;
    if (sortingField !== "") {
      let sort = sortingField.split(" ");
      setSortingField(sort[0]);
      setSortingOrder(sort[1]);
    } else {
      setSortingField("order_id");
      setSortingOrder("desc");
    }
  };

  return (
    <>
      <Container>
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Reports</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter">
              <ReportFilter
                search={handleSearch}
                advSearch={handleAdvanceSearch}
                requestorid={user.requestorid}
                investigatorid="0"
                reportTypes={reportTypes}
                reportFilterChange={reportFilterChange}
                searchPlaceHolder="Search by applicant name"
                displayShort={true}
                shortFields={[
                  {
                    text: "Report No ↑ ",
                    value: "order_report_mapping_id asc",
                  },
                  {
                    text: "Report No ↓ ",
                    value: "order_report_mapping_id desc",
                  },
                  { text: "Applicant ↑", value: "order_applicant_name asc" },
                  { text: "Applicant ↓", value: "order_applicant_name desc" },
                  { text: "Report Type ↑", value: "report_name asc" },
                  { text: "Report Type ↓", value: "report_name desc" },
                  {
                    text: "Date Completed ↑",
                    value: "order_completion_date asc",
                  },
                  {
                    text: "Date Completed ↓",
                    value: "order_completion_date desc",
                  },
                ]}
                sortOrder={handleSorting}
              />
            </div>
          </Col>
        </Row>
        {/* <Row className="quick-filter-badge-row">
          <Col>
            <div className="quick-filter-badge">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip className="quick-filter-tooltip">
                    Historical Reports
                  </Tooltip>
                }
              >
                <Badge
                  bg="secondary"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/Customer/HistoricalReport")}
                >
                  Historical Reports
                </Badge>
              </OverlayTrigger>
            </div>
          </Col>
        </Row> */}
        <Row className="reports-card-row">
          {customerReportdata.slice(0, visible).map((reportlist) => (
            <Col xl={4} lg={4} md={6} sm={12} key={reportlist.orderId}>
              <div className="cards">
                <div className="cards-head">
                  <div className="cards-title h5">
                    Report No: {reportlist.orderId}
                  </div>
                </div>
                <div className="cards-body">
                  <div className="cards-text">
                    <div className="cards-list-group">
                      <div className="cards-list-item">
                        <span>Applicant:</span> {reportlist.applicantName}
                      </div>
                      <div className="cards-list-item">
                        <span>Report Type:</span> {reportlist.templateName}
                      </div>
                      <div className="cards-list-item">
                        <span>Customer:</span> {reportlist.customerName}
                      </div>
                      <div className="cards-list-item">
                        <span>Date Completed:</span> {reportlist.completionDate}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    reportlist.isPrimary &&
                    !reportlist.templateName.includes("Pdf Reports") &&
                    reportlist.completionDate != null
                      ? "reports-action-btn"
                      : "hide-div"
                  }
                >
                  <Link
                    className="cards-link"
                    to={"/Report?type=view&id=" + reportlist.id}
                    target="_blank"
                  >
                    View Report
                  </Link>
                  <Link
                    className="cards-link"
                    to={`/Report?type=view_download&id=${reportlist.id}&reportname=${reportlist.templateName}`}
                    target="_blank"
                  >
                    Download
                  </Link>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <div
          className={
            showLoadMore ? "text-center my-5" : "text-center my-5 hide-div"
          }
        >
          <button onClick={loadMoreData} className="btn-load-more">
            Load More...
          </button>
        </div>
      </Container>
    </>
  );
}
